var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ExperianAddressLookupProvider = (function () {
    function ExperianAddressLookupProvider(addressApi) {
        this.addressApi = addressApi;
    }
    ExperianAddressLookupProvider.prototype.lookupAddress = function (postcode, limit) {
        if (limit === void 0) { limit = 50; }
        return this.addressApi.get("search?country=GBR&query=" + postcode + "&take=" + limit);
    };
    ExperianAddressLookupProvider.prototype.transformResults = function (response) {
        var _this = this;
        if (response &&
            Array.isArray(response.data.results) &&
            response.data.results.length > 0) {
            return Promise.all(response.data.results.map(function (_a) {
                var format = _a.format;
                var url = format.split('v2/').slice(-1)[0];
                return _this.addressApi.get(url).then(function (_a) {
                    var data = _a.data;
                    var addressObject = _this.extractToObject(data.address);
                    var addressToOurFormat = {
                        addressLine1: addressObject.addressLine1 || '',
                        addressLine2: addressObject.addressLine2 || '',
                        addressLine3: addressObject.addressLine3 || '',
                        postTown: addressObject.locality || '',
                        postcode: addressObject.postalCode || '',
                        county: addressObject.province || '',
                        country: addressObject.country || '',
                    };
                    return addressToOurFormat;
                });
            }));
        }
        else {
            return Promise.resolve([]);
        }
    };
    ExperianAddressLookupProvider.prototype.extractToObject = function (address) {
        if (address === void 0) { address = []; }
        return address.reduce(function (acc, val) {
            var _a;
            var key = Object.keys(val)[0];
            if (key) {
                return __assign(__assign({}, acc), (_a = {}, _a[key] = val[key], _a));
            }
            else {
                return acc;
            }
        }, {});
    };
    return ExperianAddressLookupProvider;
}());
export { ExperianAddressLookupProvider };
export default ExperianAddressLookupProvider;
//# sourceMappingURL=experianAddressLookupProvider.js.map